import { useParams } from 'react-router-dom';

import { useGetAiAgentAsCsList } from '../../../../../../shared/apis/ai-agent/ascs/reactQueries';

import AsCsPageLayout from '../Common/ui/AsCsPageLayout';
import useAiAgentAsCsFilters from './hooks/useAiAgentAsCsFilters';
import AsCsListTable from './ui/asCsListTable';
import AiAgentAsCsFilterSection from './ui/filterSection';

export default function AiAgentAsCs() {
  const { companyId } = useParams();
  const {
    filterForm,
    queryParams,
    sortBy,
    order,
    modelOptions,
    searchType,
    inputRef,
    updateFilterForm,
    handleSearchType,
    handleSearch,
    resetSearchInput,
    resetFilters,
    handlePageChange,
    handleSortChange,
  } = useAiAgentAsCsFilters(Number(companyId));

  const { data, isLoading, isError } = useGetAiAgentAsCsList(queryParams);

  return (
    <AsCsPageLayout>
      <AiAgentAsCsFilterSection
        filterForm={filterForm}
        modelOptions={modelOptions}
        searchType={searchType}
        inputRef={inputRef}
        onChangeFilterForm={updateFilterForm}
        onChangeSearchType={handleSearchType}
        handleSearch={handleSearch}
        resetSearchInput={resetSearchInput}
        onReset={resetFilters}
      />
      <AsCsListTable
        data={data}
        page={queryParams.page}
        size={queryParams.size}
        sortBy={sortBy}
        order={order}
        isLoading={isLoading}
        isError={isError}
        onPageChange={handlePageChange}
        onSortChange={handleSortChange}
      />
    </AsCsPageLayout>
  );
}
